import { gql } from '@apollo/client';
import { Select } from 'antd';
import { useQuery } from 'hooks/apollo';
import React from 'react';

const SEGMENTS_QUERY = gql`
  query Segments {
    segments {
      id
      title
    }
  }
`;

const SegmentSelector = ({ value, onChange }) => {
  const { data } = useQuery(SEGMENTS_QUERY);

  const segmentOptions = data?.segments?.map((segment) => ({ label: segment.title, value: segment.id }));

  return (
    <Select options={segmentOptions} value={value} onChange={onChange} style={{ minWidth: 200 }} />
  );
};

export default SegmentSelector;
